import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20productivity%20workspace%20with%20laptop%20showing%20clean%20spreadsheet%20interface%2C%20luxury%20leather%20notebook%2C%20gold%20pen%2C%20small%20potted%20plant%2C%20warm%20golden%20sunlight%20streaming%20through%20large%20window%2C%20cream%20and%20beige%20neutral%20palette%2C%20minimalist%20editorial%20photography%2C%20soft%20shadows%2C%20high-end%20office%20aesthetic&width=1600&height=900&seq=hero-fresh-01&orientation=landscape"
        alt="VigorBuy Spreadsheet - Professional Productivity Workspace"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-primary-500/80 backdrop-blur-sm text-white text-xs font-semibold mb-6">
            <span className="w-3.5 h-3.5 inline-flex items-center justify-center">
              <i className="ri-star-fill text-[10px]"></i>
            </span>
            Premium Spreadsheet Solutions
          </span>

          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            VigorBuy Spreadsheet
          </p>

          <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-4 leading-relaxed">
            Discover powerful business spreadsheet tools designed to streamline your workflow. Shop quality products while exploring professional templates that enhance productivity.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Shop VigorBuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full border-2 border-white/60 text-white hover:bg-white hover:text-foreground-900 transition-all whitespace-nowrap"
            >
              Read the Guide
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-book-open-line"></i>
              </span>
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-5 text-white/80 text-xs">
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line"></i>
              </span>
              Secure Shopping
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-truck-line"></i>
              </span>
              Fast Shipping
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-customer-service-line"></i>
              </span>
              Quality Support
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}